var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"position":"relative"}},[_c('d-navbar',{staticClass:"bg-navbar",staticStyle:{"z-index":"151","position":"fixed","width":"100%","top":"0"}}),_c('v-main',{class:_vm.$vuetify.theme == 'dark'? '': 'bg',staticStyle:{"margin-top":"68px"}},[_vm._t("default")],2),_c('support-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }